import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

export const getInitialState = () => ({
  recordings: {},
  searchTerm: '',
  isLoading: false,
  currentPage: 1,
  recordingsPerPage: 25,
  recordingsCount: 0,
  isCreateRecordingDialogOpened: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
